<template>
  <div class="content-430">
    <div class="search-wrap">
      <Form
        ref="formInline"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem class="sch-form-item" label="">
            <Cascader
              v-model="formValidate.classData"
              :data="gradeAndClassList"
              clearable
              change-on-select
              placeholder="请选择年级班级"
            ></Cascader>
          </FormItem>
          <FormItem class="sch-form-item" label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem class="sch-form-item" label="">
            <Select
              v-model="formValidate.classTypeShow"
              placeholder="请选择课程类型"
              class="search-select-430"
            >
              <Option
                v-for="item in courseTypeListData"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <Button
            type="primary"
            style="margin-right: 8px"
            @click="handleSearch"
          >查询</Button>
          <Button @click="handleReset">重置</Button>
        </Row>
      </Form>
    </div>
    <div class="table-title-special-430 flex justify-content_end">
      <Button
        type="primary"
        @click="handleShowDownloadModal"
      >下载班级报名明细</Button>
    </div>
    <div class="table-wrap">
      <Table
        :columns="columns"
        :data="tableList"
        :max-height="tableHeight - 140"
        :loading="loading"
        border
      >
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        show-sizer
        show-elevator
        show-total
        class="text-right mb-5 mt-5"
        :current="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        :page-size-opts="pageSizeOpts"
        @on-change="handlePage"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Modal
      v-model="modalShow"
      :width="800"
      title="选择下载导出内容"
      :footer-hide="true"
      :closable="true"
    >
      <div class="modal-content">
        <RadioGroup v-model="downloadSelectType">
          <Radio
            v-for="(item, index) in downloadContent"
            :key="index"
            :label="item.value"
          >
            {{ item.label }}
          </Radio>
        </RadioGroup>
      </div>
      <div class="modal-btn">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleNextStep">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="courseTypeShow"
      :width="800"
      title="导出"
      :footer-hide="true"
      :closable="true"
      @on-visible-change="handleResetCourse"
    >
      <CourseTypes ref="courseTypesRef" :type-ids="typeIds" :show-type="formValidate.classTypeShow" class="course-content"></CourseTypes>
      <Alert type="warning">说明：根据所选的课程类别，将在课程报名统计表中显示是否包含该课程类别的课程。</Alert>
      <div class="modal-btn">
        <Button @click="handleCancelType">取消</Button>
        <Button type="primary" @click="handleSureDownload">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="showExportModal"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelExport"
    >
      <Progress :percent="percent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelExport">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
// import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import { mapState, mapMutations } from 'vuex';
import common from '@/request/common/index.js';
import analysisCenterApi from '@/request/analysisCenter/index.js';
import {
  tableColumnsWidth,
  key
} from '@/assets/js/resetTableStyle';
import axios from 'axios';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import CourseTypes from '@c/Base/CourseTypes.vue';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
let IntervalId;
export default {
  name: 'AnalysisCenterDataAnalysisCourseEnrollAnalysis',
  components: {
    CourseTypes,
    CascaderYearTerms
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      initYear: [],
      yearTerms: [],
      portOrg: -1,
      orgId: '',
      formValidate: {
        // termIdShow: '',
        classData: [],
        gradeId: '',
        classId: '',
        classTypeShow: 'all'
      },
      gradeAndClassList: [], // 年级班级列表
      courseTypeListData: [
        {
          value: 'all',
          label: '全部课程类型'
        },
        {
          value: '1',
          label: '素质课程'
        },
        {
          value: '2',
          label: '托管'
        }
      ],
      columns: [
        key('学校', 'schoolName', tableColumnsWidth.type3),
        key('学期', 'yearTermName', tableColumnsWidth.type5),
        key('年级', 'gradeName', tableColumnsWidth.type1),
        key('班级', 'className', tableColumnsWidth.type1),
        key('班主任', 'headTeacherName', tableColumnsWidth.type4),
        key('在读人数', 'memCount', tableColumnsWidth.type2),
        key('已报名人数', 'enrolledNum', tableColumnsWidth.type2),
        key('已报名人次', 'enrolledCount', tableColumnsWidth.type2),
        key('未报名人数', 'notEnroll', tableColumnsWidth.type2)
      ],
      tableList: [],
      termList: [],
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      loading: false,
      pageSizeOpts: [10, 20, 50, 100],
      modalShow: false,
      downloadSelectType: -1,
      downloadContent: [
        {
          label: '导出全部数据（含未报名）',
          value: 3
        },
        {
          label: '导出已报名学生数据',
          value: 1
        },
        {
          label: '导出未报名学生数据',
          value: 0
        }
      ],
      selectTerm: '',
      source: null,
      showExportModal: false,
      percent: 0, // 进度条,
      courseTypeShow: false,
      dataChange: 1,
      typeIds: []
    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState'])
  },
  created() {
    // 学年学期
    if (this.$route.query.yearCode && this.$route.query.termCode) {
      this.initYear[0] = Number(this.$route.query.yearCode);
      this.initYear[1] = this.$route.query.termCode;
    }
    this.portOrg = Number(localStorage.getItem('portOrg'));
    if (this.portOrg === 2) {
      this.orgId = this.userInfo.orgId;
      this.getGradeAndClass();
      // this.initList();
      // this.getTeacherTimeTableList();
    } else {
      this.$nextTick(() => {
        // this.orgId = localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
        this.orgId = this.schoolIdForState ? this.schoolIdForState : '';
        this.getGradeAndClass();
        // this.initList();
      });
    }
  },
  mounted() {
    this.$eventHub.$on('changeSchool', id => {
      this.orgId = id;
      this.getGradeAndClass();
      this.initList();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('AnalysisCenterDataAnalysisCourseEnrollAnalysis');
    next();
  },
  activated() {
    this.$eventHub.$on('changeSchool', id => {
      this.orgId = id;
      this.getGradeAndClass();
      this.initList();
    });
    this.getEnrollStatisticsData();
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    onCascaderChange(v) {
      console.log(v, '学期变化了-----------', this.dataChange);
      this.yearTerms = v;
      // this.formValidate.yearCode = v[0];
      // this.formValidate.termCode = v[1];
      if (this.dataChange === 1) {
        console.log('来请求接口-----');
        this.handleSearch();
        this.dataChange++;
      }
    },
    // 请求年级班级列表
    async getGradeAndClass() {
      const params = {
        schoolId: this.orgId
      };
      const res = await common.getListOrgGradeClass(params);
      if (res.status === 200) {
        this.gradeAndClassList = res.message;
      }
    },
    async initList() {
      this.resetData();
    },
    resetData() {
      this.formValidate.classTypeShow = 'all';
      this.pageInfo.pageNum = 1;
      this.formValidate.classData = [];
      this.getEnrollStatisticsData();
    },
    // 获取报名数据
    async getEnrollStatisticsData() {
      const params = {
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
        schoolId: this.orgId
      };
      params.classType = this.formValidate.classTypeShow === 'all' ? null : this.formValidate.classTypeShow;
      params.gradeId = this.formValidate.classData[0] ? this.formValidate.classData[0] : null;
      params.classId = this.formValidate.classData[1] ? this.formValidate.classData[1] : null;

      if (this.yearTerms.length && this.yearTerms[1]) {
        params.yearCode = this.yearTerms[0];
        params.termCode = this.yearTerms[1];
      } else {
        params.yearCode = '';
        params.termCode = '';
      }

      this.loading = true;
      this.pageInfo.total = 0;
      this.tableList = [];

      const res = await analysisCenterApi.getEnrollStatisticsApi(params);
      this.loading = false;
      if (res.status === 200) {
        this.pageInfo.total = +res.message.total;
        this.tableList = res.message.list;
      }
    },
    handleSearch() {
      this.pageInfo.pageNum = 1;

      this.getEnrollStatisticsData();
    },
    handleReset() {
      this.resetData();
    },
    handlePage(page) {
      this.pageInfo.pageNum = page;
      this.getEnrollStatisticsData();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getEnrollStatisticsData();
    },
    handleShowDownloadModal() {
      this.modalShow = true;
    },
    handleCancel() {
      this.downloadSelectType = -1;
      this.modalShow = false;
    },
    handleNextStep() {
      if (this.downloadSelectType === -1) {
        this.$Message.error('请先选择下载导出内容！');
        return;
      }
      this.courseTypeShow = true;
    },
    handleCancelType() {
      this.courseTypeShow = false;
    },
    handleSureDownload() {
      // if (this.downloadSelectType === -1) {
      //   this.$Message.error('请先选择下载导出内容！');
      //   return;
      // }
      // console.log(this.$refs.courseTypesRef.getResult());
      const { hostingType, quelityType, typeIds } = this.$refs.courseTypesRef.getResult();
      if (typeIds.length === 0) {
        this.$Message.error('请选择课程类别');
        return false;
      }
      this.downloadData(typeIds);
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 导出-进度条
    handleCancelExport() {
      this.source.cancel('取消请求');
    },
    async downloadData(typeIds) {
      const params = {
        schoolId: this.orgId,
        typeList: typeIds,
        pageSize: this.pageInfo.total,
        pageNum: 1
      };
      this.formValidate.classData[0] ? params.gradeId = this.formValidate.classData[0] : '';
      this.formValidate.classData[1] ? params.classId = this.formValidate.classData[1] : '';

      if (this.yearTerms.length && this.yearTerms[1]) {
        params.yearCode = this.yearTerms[0];
        params.termCode = this.yearTerms[1];
      } else {
        params.yearCode = '';
        params.termCode = '';
      }
      this.downloadSelectType !== 3 ? params.enrollState = this.downloadSelectType : '';
      this.percentShow();
      this.showExportModal = true;
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const res = await analysisCenterApi.downloadDataStatisticsApi(params, this.source.token);
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
              this.courseTypeShow = false;
              this.modalShow = false;
              this.downloadSelectType = -1;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.showExportModal = false;
      }
    },
    handleResetCourse(status) {
      if (status) {
        if (this.formValidate.classTypeShow === 'all') {
          this.typeIds = ['11', '12', '13', '14', '15', '21', '22', '23', '24'];
        } else if (this.formValidate.classTypeShow == '1') {
          this.typeIds = ['11', '12', '13', '14', '15'];
        } else if (this.formValidate.classTypeShow == '2') {
          this.typeIds = ['21', '22', '23', '24'];
        } else {
          this.typeIds = [];
        }
      }
      // if (!status) {
      //   this.$refs.courseTypesRef && this.$refs.courseTypesRef.handleClear();
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-content {
  /deep/.ivu-radio-group {
    display: flex;
    flex-direction: column;
    label + label {
      margin-top: 20px;
    }
  }
}
.modal-btn {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 20px;
  }
}
.course-content {
  margin-bottom: 30px;
}
</style>
